const baseURL: string = import.meta.env.BASE_URL || '/';

/** Path for router and anchors (respects Vite `base`). */
export function resolveRouterPath(unresolvedPath?: string): string {
  let resolvedPath = baseURL;
  if (unresolvedPath) {
    resolvedPath = resolvedPath + unresolvedPath;
  }
  return resolvedPath;
}

/** Dedicated contact page (all ways to reach the business). */
export function contactHref(): string {
  return resolveRouterPath('contact');
}

/**
 * URLPattern pathname for SPA catch-all (must be registered after all concrete routes).
 * With Vite `base: "/"` this is `/*`.
 */
export function catchAllRouterPath(): string {
  const trimmed = baseURL.replace(/\/?$/, '');
  return `${trimmed}/*`;
}
